import PropTypes from 'prop-types';
import React from 'react';
import I18n from 'apps/new-web/views/components/i18n';
import Image from 'apps/new-web/views/components/image';
import BenefitsListDesktop from './benefits-list-desktop';
import BenefitsListMobile from './benefits-list-mobile';

const FusionMemberBenefits = (props) => {
  return (
    <section className="fusion-benefits-component">
      <div className="fusion-flexbox-container">
        <span id="arrow-anchor" aria-hidden="true" />
        <h2><I18n>Cardio Meets Strength</I18n></h2>
        <h3><I18n>The Best of Both Worlds</I18n></h3>
        <hr aria-hidden="true" className="divider-base large-space" />
        <p className="callout-text">
          <I18n args={{ 'emO': '<em>', 'emC': '</em>' }}>
                    Finally, a machine that combines both cardio and strength workouts to save you time [emO]and[emC] give you the total-body makeover you've been dreaming of.
          </I18n>
        </p>
      </div>
      <Image src="/pages/fusion/components/img/Nexus.jpg" alt={ I18n.translate('Watch workouts on your [android] enabled tablet.', { 'android': 'Android™' }) } />
      <div>
        { props.mediaType === 'mobile'
          ? <BenefitsListMobile />
          : <BenefitsListDesktop /> }
      </div>
    </section>
  );
};

FusionMemberBenefits.propTypes = {
  mediaType: PropTypes.string.isRequired
};

export default FusionMemberBenefits;
